import {LearnerAssignmentsLink, OwnProgressTrackingLink} from '../links';
import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const LearnerMonitoringAndStatisticsGroup = (context: NavigationContext): LinkGroup => ({
    type: 'linkGroup',
    links: [
        LearnerAssignmentsLink(context),
        OwnProgressTrackingLink(context)
    ]
})

